import {FormBuilder, FormGroup} from '@angular/forms';
import {flattenObject} from '../../../../utils/object/flatten.utils';
import {AbstractEntity} from "../../../shared/entities/abstract/abstract.entity";

/**
 * Abstract form
 * @abstract
 * @class
 */
export abstract class AbstractForm {
  /**
   * Holds the form
   * @protected
   * @type {FormGroup}
   */
  protected form: FormGroup;

  /**
   * name of the form for the api
   * @protected
   * @type {string}
   */
  protected formName: string;

  /**
   * Set up the form
   * @constructor
   * @param {FormBuilder} formBuilder the FormBuilder instance
   * @param {AbstractEntity} abstractEntity the AbstractEntity containing our form data
   */
  constructor(protected formBuilder: FormBuilder,
              protected abstractEntity: AbstractEntity) {
    this.form = formBuilder.group(this.getFormConfig());
    this.form.valueChanges.subscribe((data) => this.onValueChanges(data));
  }

  /**
   * Gets the form
   * @returns {{}} the form group
   * @abstract
   * @type {FormGroup}
   */
  abstract getForm(): FormGroup;

  /**
   * Gets the form value
   * @returns {{}} the form value
   * @abstract
   * @type {object}
   */
  abstract getValue(): {};

  /**
   * gets the form config
   * @return {object} the form config
   * @protected
   * @abstract
   * @type {object}
   */
  protected abstract getFormConfig(): {};

  /**
   * fired on value changes from the valueChanges event on the form
   * we need the raw value for disabled fields like slug
   * @param {object} data the form data
   * @return {void}
   * @protected
   */
  protected onValueChanges(data): void {
    this.abstractEntity.updateValues(flattenObject(data || this.form.getRawValue()));
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/form/abstract.form.ts